import axios from '../lib/axios';
import { PRODUCTS_BRAND_FIND_MANY } from '../lib/endpoints/product';
import { BrandModel } from '../models/brand';

export const getAllBandProduct = async (): Promise<BrandModel[]> => {
  const res = await axios.post(PRODUCTS_BRAND_FIND_MANY);
  return res?.data;
};
